declare const bootstrap: any
namespace app {
    interface CustomisedService {
        init?: () => Promise<void>;
        PostSubmit?: (data?: Record<string, string>) => Promise<void>;
        PreSubmit?: (data?: any) => boolean | void;
        PostStepHandlers?: { Step: number, Handler: (data: Record<string, string>) => void }[];
        FormInit?: () => Promise<void>;
        StepComplete?: (data: any) => void;
    }

    //service customisations (PER SERVICE)
    export const CustomServiceLogic: Record<string, CustomisedService> = {
        HCPReferral: {
            async init() {
                cp.event.subscribe("app:ready", async (o: any, t: any) => {
                    //append all HCP clinics  to the form
                    // clinic attending dropdown populate based on logged in HCP's data
                    // reset form
                    const form = document.getElementsByName("HCPReferral")[0] as HTMLFormElement;
                    form.reset();

                    //append all HCP clinics  to the form
                    const data = cp.patient.get()?.PatientData;
                    if (data) {
                        const clinic = document.querySelector(`.cp-service__form[name="HCPReferral"] [name="Clinic.ExternalID"]`)!;
                        for (let c of  ["","2"]){
                            let ext = data[`Clinic${c}.ExternalID`];
                            let name = data[`Clinic${c}.ClinicName`];
                            if (ext){
                                 clinic.insertAdjacentHTML("beforeend", `<option value="${ext}">${name}</option>`);
                            }
                        }
                    } else {
                        alert("Some issue in getting HCP detail");
                    }
                });
            },
            PreSubmit(data: any) {
                // We need to map current HCP data into patient enrolment info
                const hcp = cp.patient.get();
                if (hcp && hcp.Streams[0] == "HCP") 
                    data["HCP.ExternalID"]=hcp.PatientID;
                else if(hcp && hcp.Streams[0] == "DEL")
                    data["DEL.ExternalID"]=hcp.PatientID;
                // switch program
                cp.api.switchProgram("gsk-myecare");
            },
            async PostSubmit(data: any) {
                // not needed login
                // switch back to hcp program
                cp.api.switchProgram("gsk-hcp");
                // after success message
                cp.ui.loader("hide");

                // success popup redirect
                document.querySelector<HTMLButtonElement>(".axsvc-success .btn-default")?.  addEventListener("click", () => cp.ui.navigate("/en/hcp"));
            },
            async FormInit() {
                const form = document.getElementsByName("HCPReferral")[0] as HTMLFormElement;
                // clear fields
                form.reset();
                (document.getElementById("refer-other-patient") as HTMLElement)?.addEventListener("click", () => form.reset());
                // allow DateOfBirth input field to accept past dates
                document.getElementsByName("DateOfBirth")[0].removeAttribute('min');
                const radios = document.querySelectorAll<HTMLInputElement>(
                    'input[type="radio"][name="TreatmentName"]'
                  );
                  
                const modalElement = document.getElementById('not-found-product');
                
                if (modalElement) {
                    const modal = new (window as any).bootstrap.Modal(modalElement);
                    radios.forEach((radio) => {
                        radio.addEventListener('change', () => {
                      
                          if (radio.checked && radio.value === 'NONE/UNCONFIRMED') {
                            modal.show();
                            // close btn click should close not-found-product popup
                            document.querySelectorAll<HTMLButtonElement>("#not-found-product button.btn.btn-primary")[0].addEventListener("click", () => {
                                modal.hide()
                                const radioToSelect = document.querySelector<HTMLInputElement>('input[name="TreatmentName"][value="Blenrep"]');
                                if(radioToSelect)
                                    radioToSelect.checked = true;
                            });
                          }
                      
                        });
                      });
                
                }
            }
        },
        PatientContinuingTreatment: {
            async init() {
                cp.event.subscribe("app:ready", async (o: any, t: any) => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const patientId = parseInt(urlParams.get('p') as string);
                    const form = document.querySelector("form[name=PatientContinuingTreatment]");
                    
                    if (patientId && !isNaN(patientId)){
                        cp.api.switchProgram("gsk-myecare");
                       await cp.patient.loadById(patientId);                            
                    }

                    // Step2. let HCP fill the form & submit
                    if (cp.patient.get()?.PatientID!=patientId) {
                        form?.insertAdjacentHTML("afterend",`<div class="alert alert-danger" role="alert">
                            Invalid link or patient.</div>`);
                        form?.remove();
                            return;
                    }  
                });
               
            }
        
        },
        HcpDelegateRegister: {
            async FormInit() {
                const form = document.getElementsByName("HcpDelegateRegister")[0] as HTMLFormElement;
                form.reset();
            },
            StepComplete(data: any) {
                const formRowToHide = document.querySelector("[name='PrescriberFirstName']")?.closest(".form-row") as HTMLDivElement | null;
                if(data?.data?.HCPRole && data.data.HCPRole != "I am a delegate for a haematologist") {
                    formRowToHide?.classList.add("d-none");
                    (formRowToHide?.nextElementSibling as HTMLDivElement | null)?.classList.add("d-none");
                } else {
                    formRowToHide?.classList.remove("d-none");
                    (formRowToHide?.nextElementSibling as HTMLDivElement | null)?.classList.remove("d-none");
                }
            }
        },
        PatientEnrolmentCompletion:{
            async FormInit() {
                const form = document.getElementsByName("PatientEnrolmentCompletion")[0] as HTMLFormElement;
                const ptData = cp.patient.get();
                let isDelegateReferred = false;
                if("DEL.ExternalID" in ptData?.PatientData!) {
                    isDelegateReferred = true;
                }

                if(!isDelegateReferred) {
                    document.getElementsByName("PrescriberFirstName")[0]?.closest(".form-row")?.classList.add("d-none");
                    document.getElementById("your-referrers-name")?.classList.add("d-none");
                }

            }
        },
    }


    // all methods subscribed immediately
    cp.event.subscribe("service:show", (serviceName: any, d: any) => {
        //if we have customisations for this service then run them
        Object.keys(CustomServiceLogic).forEach((key) => {
            if (key.toLowerCase() == serviceName && CustomServiceLogic[key].init) {
                CustomServiceLogic[key].init?.();
            }
        });
    });

    cp.event.subscribe("service:submit", (serviceName: any, data: any) => {
        //if we have SUBMIT customisations for this service then run them
        if (CustomServiceLogic[serviceName] && CustomServiceLogic[serviceName].PreSubmit)
            CustomServiceLogic[serviceName].PreSubmit?.(data);
    });
    cp.event.subscribe("service:success", (serviceName: any, data: any) => {
        //if we have SUBMIT customisations for this service then run them
        if (CustomServiceLogic[serviceName] && CustomServiceLogic[serviceName].PostSubmit)
            CustomServiceLogic[serviceName].PostSubmit?.(data);
    });

    cp.event.subscribe("form:load", (serviceName: any, data: any) => {
        Object.keys(CustomServiceLogic).forEach((key) => {
            if (key.toLowerCase() == serviceName && CustomServiceLogic[key].FormInit) {
                CustomServiceLogic[key].FormInit?.();
            }
        });
    });

    cp.event.subscribe("app:ready", (serviceName: any, data: string) => {
        if (PageCustomisations[data]) PageCustomisations[data]();
        //insertLogoutBtn();
    });

    cp.event.subscribe("service:stepComplete", (serviceName: any, data: any) => {
        if (CustomServiceLogic[serviceName] && CustomServiceLogic[serviceName].StepComplete)
            CustomServiceLogic[serviceName].StepComplete?.(data);
    });



    cp.event.subscribe("login:success", (serviceName: any, data: any) => {
        cp.ui.closeAllModals();
        const patientDetails = cp.patient.get();
         const params = new URLSearchParams(window.location.search);
        const redirectUrl = params.has("ReturnURL") ? params.get("ReturnURL") : params.get("returnTo");
         if (redirectUrl) cp.ui.navigate(redirectUrl);
        else if(patientDetails && Array.isArray(patientDetails?.Streams)) {
            if(patientDetails?.Streams[0] == "ECP") {
                    cp.ui.navigate("/en/ecp");
                } else if(patientDetails?.Streams[0] == "HCP" || patientDetails?.Streams[0] == "DEL") {
                    cp.ui.navigate("/en/hcp");
                }
        } else {
            // Other user login
            cp.ui.navigate("/en");
        }
    });

   
}
const PageCustomisations: Record<string, () => Promise<void>> = {
    //ccustomisations per page type
    StartPage: async () => {
        const params = new URLSearchParams(window.location.search);
        if (params.has("ReturnURL")) {
            cp.services.showLogin();
        }
        //customise the optometrist login button
        var optLoginBlock = document.querySelector(".content-block--callout");
        if (optLoginBlock){
           optLoginBlock.addEventListener("click",e=>{
            //on click bubble of any button.. if this is login then customise style class of login form
            //this enables custom content to be revealed if needed (eg. different registration action )
            if ((e.target as HTMLElement).getAttribute("data-action")?.toLowerCase()=="service.login"){
                document.querySelector(".cp-service--login")?.classList.add("store-mode");
            }
           }); 
        }
    },
    ArticleLandingPage: async () => {
        const prevLabel = "Previous";
        const nextLabel = "Next";
        let currentPage = 1;
        let maxItem = 0; // Count of total list of articles present in DOM
        let maxItemsPerPage = 0; //Display the list of articles as per the number given, if not display 6 by default
        let pageCount = 0; // Count of total number of pages that will be visible in DOM for pagination
        let data: any; // Array of HTMLElement for all articles items already in DOM
        let itemCountForHeader = 0; // Count of item display on header
        const listingsWithPagination = document.querySelectorAll('.cms-listing[data-pagination="yes"]');
        // Convert NodeList to Array 
        const listingsArray = Array.from(listingsWithPagination);

        listingsArray.forEach((item) => {
            /*-----Footer of CMS Listing with Pagination as Yes-----*/
            // Get max items per page from attribute
            const maxPageSizeAttr = item.getAttribute("data-maxpagesize");
            if (!maxPageSizeAttr) {
                console.error("max page item not provided for:", item);
                return;
            }

            maxItemsPerPage = parseInt(maxPageSizeAttr, 10);

            // Find footer inside this listing
            const footer = item.querySelector(".cms-listing__footer");

            // Get all items inside this listing
            data = Array.from(item.querySelectorAll(".cms-listing__item"));
            // total items
            maxItem = data.length;

            // Calculate page count
            pageCount = Math.ceil(maxItem / maxItemsPerPage);

            if (!footer) {
                console.error("No footer found in listing:", item);
                return;
            }

            // Create pagination container
            const paginationContainer = document.createElement("div");
            paginationContainer.className = "pagination m-3";
            footer.appendChild(paginationContainer);

            // First render
            renderPagination(paginationContainer);
            renderData(item, currentPage);

            // Handle pagination clicks
            paginationContainer.addEventListener("click", (e) => {
                const target = e.target as HTMLElement;
                if (target.tagName === "BUTTON") {
                    const page = target.dataset.page;

                    if (page === "prev" && currentPage > 1) {
                        currentPage--;
                    } else if (page === "next" && currentPage < pageCount) {
                        currentPage++;
                    } else if (page) {
                        currentPage = parseInt(page, 10);
                    }

                    renderPagination(paginationContainer);
                    renderData(item, currentPage);
                }
            });
        });


        // param container - The HTML element where pagination buttons will be rendered.
        const renderPagination = (container: HTMLElement) => {
            container.innerHTML = "";

            // Previous Button
            const prevBtn = document.createElement("button");
            prevBtn.className = "btn mx-1 nav-button";
            prevBtn.textContent = prevLabel;
            prevBtn.disabled = currentPage === 1;
            prevBtn.dataset.page = "prev";
            container.appendChild(prevBtn);

            // Page Numbers
            for (let i = 1; i <= pageCount; i++) {
                const pageBtn = document.createElement("button");
                pageBtn.className = `btn mx-1 page-button ${i === currentPage ? "active" : ""}`;
                pageBtn.textContent = i.toString();
                pageBtn.dataset.page = i.toString();
                container.appendChild(pageBtn);
            }

            // Next Button
            const nextBtn = document.createElement("button");
            nextBtn.className = "btn mx-1 nav-button";
            nextBtn.textContent = nextLabel;
            nextBtn.disabled = currentPage === pageCount;
            nextBtn.dataset.page = "next";
            container.appendChild(nextBtn);
        }

        /* @param {Element} item - Element of CMS listing
        * @param {number} page - The page number to render data for 
        */
        const renderData = (item: Element, page: number) => {
            // hide all
            data.forEach((item: HTMLElement) => {
                (item as HTMLElement).style.display = "none";
            });

            // show only items of current page
            const start = (page - 1) * maxItemsPerPage;
            const end = start + maxItemsPerPage;

            if (end < maxItem) {
                itemCountForHeader = end;
            } else {
                itemCountForHeader = maxItem;
            }

            renderOrUpdatePageHeader(item, itemCountForHeader, maxItem);
            for (let i = start; i < end && i < maxItem; i++) {
                (data[i] as HTMLElement).style.display = "block";
            }
        }

        /*
         * @param item - The DOM element containing the header element.
         * @param currentPage - The current page number to display.
         * @param totalPage - The total number of pages to display.
         */
        const renderOrUpdatePageHeader = (
            item: Element,
            currentPage: number,
            totalPage: number
        ): void => {
            const headerContainer = item.querySelector(".cms-listing__pagination-header");

            if (!headerContainer) return;

            // If placeholders still exist replace with spans
            if (headerContainer.innerHTML.includes("{currentPage}") || headerContainer.innerHTML.includes("{totalPage}")) {
                headerContainer.innerHTML = headerContainer.innerHTML
                    .replace("{currentPage}", `<span class="currentPage">${currentPage}</span>`)
                    .replace("{totalPage}", `<span class="totalPage">${totalPage}</span>`);
                return;
            }

            // Otherwise update existing spans
            const currentPageEl = headerContainer.querySelector<HTMLSpanElement>(".currentPage");
            const totalPageEl = headerContainer.querySelector<HTMLSpanElement>(".totalPage");

            if (currentPageEl) currentPageEl.textContent = String(currentPage);
            if (totalPageEl) totalPageEl.textContent = String(totalPage);
        };

    },
    HomePage: async () => {
        
    },
    PublicPage: async () => {
        // Remove home page navigation link from Patient pages
        if(window.location.pathname.includes("/patient/")) {
            const homeLink = document.getElementById("home-link");
            homeLink?.remove();
        }
    }

}

function insertLogoutBtn(): void {
    const navUl =
            document.querySelector('.navbar-nav');
            navUl?.insertAdjacentHTML("beforeend",`<li class="nav-item"><a class="nav-link" href="javascript:void(0)">Logout</a></li>`);
            const link = navUl?.querySelector("li:last-child a");
           link?.addEventListener('click', async () => {
            try {
                await cp.user.logout();
            } finally {
                cp.ui.navigate("/en");
            }
        });
}

function externalLinkHandler(): void {
    document.addEventListener("click", function (event) {
        // add target=blank to anchor tag with link 
        const target = event.target as HTMLElement;

        const anchor = target.closest("a.has-link") as HTMLAnchorElement | null;

        if (anchor && anchor.href) {
            if (anchor.target !== "_blank") {
                event.preventDefault();
                window.open(anchor.href, "_blank", "noopener,noreferrer");
            }
        }

        // tooltip close in desktop if clicked outside
        // Check if the click was outside the tooltip and its target button
        const path = event.composedPath() as HTMLElement[];

        const clickedInsideTooltip = path.some(el =>
            el instanceof HTMLElement &&
            (el.classList?.contains('tooltip') ||
                el.classList?.contains('tooltip-trigger'))
        );

        if (!clickedInsideTooltip) {
            document.querySelectorAll('.tooltip').forEach((tooltip) => {
                (tooltip as HTMLElement).style.display = 'none';
            });
        }
    });
}